import type { ApiRequestMessage, ApiResponseMessage } from '@prospective/pops-shared';

// original POPS action URLs: /v1/publications/{pubkey}/interactions/funnel.* (submit, track_section
// — kept funnel-named) or form.* (verification.*, shared with the Application Form path)
// (the proxy rewrite to /v1/publication/pops/… happens later, inside realApiRequestHandler,
// so the URL here is still in the original POPS format)
const FORM_INTERACTION_RE = /\/v1\/publications\/[^/]+\/interactions\/(?:funnel\.|form\.)/;

/** Returns true for mutating form-flow calls that must be intercepted in preview mode. */
export function isFormPreviewRequest(req: ApiRequestMessage): boolean {
  const path = new URL(req.url, window.location.origin).pathname;
  return FORM_INTERACTION_RE.test(path);
}

/**
 * Returns a synthetic success response so the form flow can advance through all
 * steps without any real API call — no EC-DataVault write, no OTP send, no submission.
 */
export function mockFormResponse(req: ApiRequestMessage): ApiResponseMessage {
  return {
    type: 'API_RESPONSE',
    requestId: req.requestId,
    ok: true,
    status: 200,
    data: {},
  };
}
